import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import RiderPreview from "@/components/rider/RiderPreview";
import { Bike, TriangleAlert, Loader2 } from "lucide-react";

export default function PublicPreview() {
  const { pathId } = useParams();
  const [sp] = useSearchParams();
  const zone = sp.get("zone");
  const pl = sp.get("pl");
  const [revoked, setRevoked] = useState(null);

  useEffect(() => {
    if (!pl) { setRevoked(false); return; }
    api.get("/rider-preview/status", { params: { pl } })
      .then((r) => setRevoked(!!r.data.revoked))
      .catch(() => setRevoked(false));
  }, [pl]);

  return (
    <div className="min-h-screen bg-background" data-testid="public-preview-page">
      <header className="border-b border-border bg-card">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-2">
          <Bike className="w-5 h-5 text-primary" />
          <span className="font-heading font-bold">Velopaths</span>
          <span className="text-muted-foreground text-sm">· Rider Preview</span>
        </div>
      </header>
      <main className="max-w-7xl mx-auto p-4">
        {revoked === null ? (
          <div className="py-24 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>
        ) : revoked ? (
          <div className="max-w-md mx-auto mt-16 rounded-2xl border border-red-500/40 bg-red-500/5 p-10 text-center" data-testid="preview-revoked">
            <TriangleAlert className="w-10 h-10 text-red-500 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-bold text-red-500">Preview link revoked</h1>
            <p className="text-sm text-muted-foreground mt-2">This rider preview is no longer available. Please contact the shop or Velopaths for an updated link.</p>
          </div>
        ) : (
          <RiderPreview publicMode initialPathId={pathId} initialZoneId={zone} />
        )}
      </main>
    </div>
  );
}
